//Home
export const HOME = "/";

//LG Response Process
export const PROCESS = "/process";

//LG Security Bulletin
export const BULLETINS = "/bulletins";

export const BULLETINS_MOBILE = "/bulletins/mobile";
export const BULLETINS_MOBILE_SECURITYPOLICY = "/bulletins/mobile#securityBulletins";
export const BULLETINS_MOBILE_UPDATEDETAIL = "/bulletins/mobile#updateDetails";
export const BULLETINS_MOBILE_AERINFORMATION = "/bulletins/mobile#aerInformation";

export const BULLETINS_PC = "/bulletins/pc";
export const BULLETINS_PC_SECURITYPOLICY = "/bulletins/pc#securityBulletins";
export const BULLETINS_PC_UPDATEDETAIL = "/bulletins/pc#updateDetails";

export const BULLETINS_MONITOR = "/bulletins/monitor";
export const BULLETINS_MONITOR_SECURITYPOLICY = "/bulletins/monitor#securityBulletins";
export const BULLETINS_MONITOR_UPDATEDETAIL = "/bulletins/monitor#updateDetails";
//aading id products
export const BULLETINS_IDPRO = "/bulletins/idproducts";
export const BULLETINS_IDPRO_SECURITYPOLICY = "/bulletins/idproducts#securityBulletins";
export const BULLETINS_IDPRO_UPDATEDETAIL = "/bulletins/idproducts#updateDetails";

//aading AV products
export const BULLETINS_AVPRO = "/bulletins/avproducts";
export const BULLETINS_AVPRO_SECURITYPOLICY = "/bulletins/avproducts#securityBulletins";
export const BULLETINS_AVPRO_UPDATEDETAIL = "/bulletins/avproducts#updateDetails";

//aading Home Appliance
export const BULLETINS_HOMEAPPLIANCE = "/bulletins/homeappliance";
export const BULLETINS_HOMEAPPLIANCE_SECURITYPOLICY = "/bulletins/homeappliance#securityBulletins";
export const BULLETINS_HOMEAPPLIANCE_UPDATEDETAIL = "/bulletins/homeappliance#updateDetails";

//adding tv
export const BULLETINS_TV = "/bulletins/tv";
export const BULLETINS_TV_SECURITYPOLICY = "/bulletins/tv#securityBulletins";
export const BULLETINS_TV_UPDATEDETAIL = "/bulletins/tv#updateDetails";

//Security Reporting
export const REPORTING = "/reporting";
export const CREATE_REPORTING = "/create";

//Rewards Program
export const REWARDS = "/rewards";

//Login
export const LOGIN = "/login";
export const SIGN_UP = "/signup";

//Temrs & Condition
export const TERMS_CONDITION = "/terms";

//Privacy Policy
export const PRIVACY_POLICY = "/privacy";

//My Issue Status Test
export const MYISSUES = "/myissues";

//Report Submit
export const REPORT_SUBMIT = "/submit";